import FileIcon from './FileIcon';

export default FileIcon;
export { default as defaultStyles } from './defaultStyles/index';
